import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';

export class TransportOptionEditorDialogData {
  transportOption: TransportOption;
}

@Component({
  selector: 'app-transport-option-editor-validation',
  templateUrl: './transport-option-editor-validation.component.html',
  styleUrls: ['./transport-option-editor-validation.component.scss']
})
export class TransportOptionEditorValidationComponent implements OnInit {

  @Input() transportOption: TransportOption;

  @Output() changed = new EventEmitter();

  showMinimumSelectedOptions = false;
  showErrorMinSelectedOptionsMin = false;

  keys = Object.keys;

  optionFormGroup = new FormGroup({});

  optionValid = false;

  constructor(
    public translationService: TranslationService) {

    this.optionFormGroup.addControl('optional', new FormControl(null, []));

    this.optionFormGroup.valueChanges.subscribe(
      value => {
        if (this.optionFormGroup.dirty) {
          this.transportOption.optional = this.optionFormGroup.controls.optional.value;
          if (this.showMinimumSelectedOptions) {
            this.transportOption.minimumSelectedOptions = +this.optionFormGroup.controls.minimumSelectedOptions.value;
            this.showErrorMinSelectedOptionsMin = +this.transportOption.minimumSelectedOptions < 0;
          }

          this.changed.emit();
        }
      }
    );
  }

  public ngOnInit() {

    if (this.transportOption.parentId == null) {
      this.showMinimumSelectedOptions = true;
      this.optionFormGroup.addControl('minimumSelectedOptions', new FormControl(null, [Validators.required, Validators.min(0)]));
      this.showErrorMinSelectedOptionsMin = this.transportOption.minimumSelectedOptions < 0;
    }

    const formdata: any = {};
    formdata.optional = this.transportOption.optional;

    if (this.showMinimumSelectedOptions) {
      formdata.minimumSelectedOptions = this.transportOption.minimumSelectedOptions;
    }

    this.optionFormGroup.reset(formdata);

  }


}
